import { TextField, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid/Grid';
import currencyFormatter from 'currency-formatter';
import { WithStyles } from 'decorators/withStyles';
import { IProductNew } from 'interfaces/product';
import React, { PureComponent } from 'react';
import rxjsOperators from 'rxjs-operators';
import { productNewService } from 'services/productNewService';
import CopyIcon from '../Icons/CopyIcon';
import TooltipHelp from '../Tooltip';
import OpenInNewIcon from 'mdi-react/OpenInNewIcon';
import { CHK_URL, SUN_URL } from 'settings';
import * as rxjs from 'rxjs';

interface IProps {
  classes?: any;
  showSunV3Url?: boolean;
}

interface IState {
  selectedProduct: IProductNew;
  visibilityTooltip: boolean;
  textInput: any;
  tooltipMessage: string;
}

@WithStyles(theme => ({
  expansionPanel: {
    padding: 0
  },
  containerProduct: {
    display: 'flex',
    width: '100%',
    padding: '24px 0',
    cursor: 'auto'
  },
  containerImg: {
    marginRight: 24
  },
  img: {
    maxWidth: 100,
    borderRadius: 4
  },
  fontName: {
    fontWeight: 'bold',
    fontSize: '1rem',
    color: '#596375',
    wordBreak: 'break-word'
  },

  price: {
    fontSize: '1rem',
    color: '#009358',
    marginBottom: 8
  },
  inputPromotionLink: {
    borderRadius: 4
  },
  svgInput: {
    '& svg': {
      width: 20
    }
  },
  copyIcon: {
    cursor: 'pointer',
    '& path': {
      fill: theme.variables.colors['primaryColor']
    }
  },
  btnInput: {
    display: 'flex'
  },
  btnExternalLink: {
    background: theme.variables.colors['primaryColor'],
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    padding: 11,
    border: 'none',
    borderRadius: 4,
    '& svg': {
      fill: '#FFF'
    },
    '&:focus': {
      border: 'none !important',
      boxShadow: 'none !important',
      outline: 'none'
    }
  },
  copyInput: {
    overflow: 'hidden',
    width: '100%',
    display: 'flex',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginRight: 10,
    fontFamily: 'Open Sans',
    fontSize: '0.875rem'
  },
  containerInputCopy: {
    marginRight: 8,
    flexShrink: 1
  },
  fidcAlert: {
    background: '#F5F5F5',
    border: '1px solid #E0E0E0',
    padding: 16,
    '& a': {
      color: '#0D47A1'
    }
  }
}))
export default class ProductQuickView extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      selectedProduct: null,
      visibilityTooltip: false,
      textInput: '',
      tooltipMessage: 'Copiar'
    };
  }

  getCheckoutUrl = (removeHttps = false) => {
    const { selectedProduct } = this.state;
    const baseUrl = this.props.showSunV3Url ? SUN_URL : CHK_URL;
    const productPath = selectedProduct?.hashId || selectedProduct?.id;

    return removeHttps ? `${baseUrl.replace('https://', '')}/${productPath}` : `${baseUrl}/${productPath}`;
  };

  focusTextInput = (event: any) => {
    event.preventDefault();
    this.state.textInput.focus();
    this.state.textInput.select();
    document.execCommand('Copy');
    this.setState({ visibilityTooltip: true, tooltipMessage: 'Copiado!' });
    setTimeout(() => this.setState({ visibilityTooltip: false, tooltipMessage: 'Copiar' }), 1500);
  };

  setTextInputValue = (input: any) => {
    this.setState({ textInput: input });
  };

  redirectCheckout = () => {
    window.open(this.getCheckoutUrl());
  };

  componentDidMount() {
    rxjs
      .combineLatest([productNewService.getSelectedProduct()])
      .pipe(rxjsOperators.bindComponent(this))
      .subscribe(([selectedProduct]) => this.setState({ selectedProduct }));
  }

  render() {
    const { selectedProduct, tooltipMessage } = this.state;
    const { classes } = this.props;

    if (!selectedProduct) {
      return null;
    }

    return (
      <div className={classes.containerProduct}>
        <div className={classes.containerImg}>
          <img className={classes.img} src={selectedProduct.image} />
        </div>
        <Grid container alignItems="baseline" spacing={8}>
          <Grid container direction="column">
            <Typography className={classes.fontName}>{`${selectedProduct.id} - ${selectedProduct.name}`}</Typography>
            <Typography className={classes.price}>
              {currencyFormatter.format(selectedProduct.price, { code: 'BRL', precision: 2 })}
            </Typography>
          </Grid>
          <Grid container>
            <div className={classes.btnInput}>
              <TextField
                inputRef={this.setTextInputValue}
                className={classes.containerInputCopy}
                InputProps={{
                  classes: { root: classes.inputPromotionLink, input: classes.copyInput },
                  endAdornment: (
                    <TooltipHelp placement="top" title={tooltipMessage}>
                      <CopyIcon onClick={this.focusTextInput} className={classes.copyIcon} />
                    </TooltipHelp>
                  )
                }}
                value={this.getCheckoutUrl(true)}
              />
              <TooltipHelp placement="top" title="Ver página">
                <button onClick={this.redirectCheckout} className={classes.btnExternalLink}>
                  <OpenInNewIcon />
                </button>
              </TooltipHelp>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}
